import React, { forwardRef, ForwardedRef, useRef } from "react";
import classNames from "classnames";
import { RadioTileProps } from "./types";

type RadioTileIconSize = "sm" | "md" | "lg";

const getIconProps = (size: RadioTileIconSize = "md") => ({
  fill: "currentColor",
  className: "rds-RadioTile-icon",
  ["aria-hidden"]: true,
  focusable: false,
});

const RadioTile = forwardRef(
  (
    {
      className,
      icon: RadioTileIcon,
      id: idProp,
      image,
      label,
      size = "md",
      vertical,
      ...rest
    }: RadioTileProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const defaultIdRef = useRef(
      `rds-radio-${Math.random().toString(36).slice(2, 16)}`
    );

    const id = idProp || defaultIdRef.current;

    const radioTileClasses = classNames(
      "rds-RadioTile",
      {
        [`rds-RadioTile--${size}`]: size !== "md",
        "rds-RadioTile--vertical": vertical,
      },
      className
    );

    return (
      <div className={radioTileClasses}>
        <input type="radio" ref={ref} id={id} {...rest} />
        <label htmlFor={id}>
          <span className="rds-RadioTile-button"></span>
          <span className="rds-RadioTile-content">
            {RadioTileIcon && !vertical && (
              <RadioTileIcon {...getIconProps(size)} />
            )}
            {image && vertical && (
              <span className="rds-RadioTile-image">{image}</span>
            )}
            {label}
          </span>
        </label>
      </div>
    );
  }
);

RadioTile.displayName = "RadioTile";

export { RadioTile as default };
